import { useQuery } from 'react-query'
import { getSettingsStructure } from 'services/cm-api/get-settings-structure'

export function useGetSettingsStructure() {
  return useQuery(['getSettingsStructure'], () => getSettingsStructure(), {})
}
